import { render, staticRenderFns } from "./popup-folder-add.vue?vue&type=template&id=c571e918&scoped=true"
import script from "./popup-folder-add.vue?vue&type=script&lang=js"
export * from "./popup-folder-add.vue?vue&type=script&lang=js"
import style0 from "./popup-folder-add.vue?vue&type=style&index=0&id=c571e918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c571e918",
  null
  
)

export default component.exports